import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';

import { CreditLog } from 'stores/credit_log_store';
import { CreditLogProps} from 'stores/credit_log_store';
import { PagedResult } from 'utils/types';

import useStores from 'hooks/useStores';

// type ClockType = {
//     key: string;
//     type: string;
// };


export type CreditLogContextType = {
    logItems: CreditLog[];
    fetchCreditLog: () => Promise<PagedResult<CreditLogProps>>;
    fetchCreditLogViaSupport: (support_identity: string, user_uuid: string, cursor: string) => Promise<PagedResult<CreditLogProps>>;
}

export const CreditLogContext = React.createContext<CreditLogContextType>({
    logItems: [] as CreditLog[],
    fetchCreditLog: () => { throw "Not implemented" },
    fetchCreditLogViaSupport: () => { throw "Not implemented" },
});

export const CreditLogProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [items, setItems] = useState([] as CreditLog[]);
    const { creditLogStore } = useStores();

    async function fetchCreditLog() {
        console.log("fetchCreditLog");
        return creditLogStore.fetchCreditLog()
            .then((data) => {
                setItems(creditLogStore.items);
                return data;
            });
    }

    async function fetchCreditLogViaSupport(support_identity: string, user_uuid: string, cursor = "") {
        return creditLogStore.fetchCreditLogViaSupport(support_identity, user_uuid, cursor);
    }

    const data = {
        logItems: items,
        fetchCreditLog: fetchCreditLog,
        fetchCreditLogViaSupport: fetchCreditLogViaSupport,
    };

    return (
        <CreditLogContext.Provider value={data}>{ children }</CreditLogContext.Provider>
    );

});
